import Vue from 'vue';
import Vuex from 'vuex';
import { Provider } from './types/response';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // Default client ID for regular customers (non-UNC)
    clientId: process.env.VUE_APP_CLIENT_ID,
    // UNC-specific client IDs
    uncClientId: process.env.VUE_APP_UNC_BACKEND_CLIENT_ID,
    serverUrl: process.env.VUE_APP_MWS_URL,
    stripePublicKey: process.env.VUE_APP_STRIPE_KEY,
    blockedUrls: [] as string[],
    publicUrl: [
      '/register',
      '/subscription-plan',
      '/pending-verification',
    ],
    preferredProviders: [],
  },
  getters: {
    // Get the current client ID based on subdomain
    SSOclientId: (state) => {
      const host = window.location.host;
      const subdomain = host.split('.')[0];
      // Check if this is a UNC subdomain
      const isUNCSubdomain = subdomain.includes('unc');
      if (isUNCSubdomain) {
        return state.uncClientId;
      } else {
        return state.clientId;
      }
    },
  },
  mutations: {
    SET_PREFERRED_PROVIDER(state, providers: Provider[]) {
      state.preferredProviders = providers as any;
    },
    setBlockedUrls(state, urls) {
      state.blockedUrls = urls;
    },
  },
  actions: {

  },
});
